class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    // Listen on the custom element, not the <details>: a split header item (docs §21) keeps
    // its title <a> outside the <details>, and focus leaving from that link never fires
    // focusout on the details — the panel stayed open with focus gone. onFocusOut already
    // scopes its check to `this`, so the wider listener changes nothing for other users.
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    // aria-expanded is no longer mirrored onto the <summary>: ARIA in HTML forbids it there,
    // and removing `open` above is already what the platform reports collapsed state from.
    // See the note at the top of assets/global.js.
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

class HeaderSplitItem extends HTMLElement {
  // Split submenu item (docs §21): the sibling <a> navigates; this element's <button> toggles
  // the in-flow accordion <ul>. The top level keeps <details>/<summary> because its panel is
  // absolutely positioned; here the panel must be a full-width row sibling of link and button,
  // which <details> cannot express.
  constructor() {
    super();
    this.toggle = this.querySelector('button[aria-expanded]');
    this.submenu = this.querySelector('.header__submenu');
    if (!this.toggle || !this.submenu) return;

    this.toggle.addEventListener('click', () => this.setExpanded(!this.expanded));
    this.addEventListener('keyup', this.onKeyUp.bind(this));
  }

  get expanded() {
    return this.toggle.getAttribute('aria-expanded') === 'true';
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE' || !this.expanded) return;
    // Close this level only: without stopPropagation the same keyup reaches the enclosing
    // details' onKeyUpEscape listener (global.js) and the whole dropdown would close at once.
    event.stopPropagation();
    this.setExpanded(false);
    this.toggle.focus();
  }

  setExpanded(expanded) {
    this.toggle.setAttribute('aria-expanded', expanded);
    this.submenu.toggleAttribute('hidden', !expanded);
  }
}

customElements.define('header-split-item', HeaderSplitItem);
